<div class="d-flex gap-2 mb-1">
  <i
    *ngFor="let shift of shifts; trackBy: trackByShift"
    [ngClass]="shift.icon"
    class="fa-regular headline-16"
    [class.text-dark-gray]="!candidateAvailability[shift.control]"
    [ngbTooltip]="
      (candidateAvailability[shift.control]
        ? ('tooltip.willingnessShift' | translate)
        : ('tooltip.noWillingnessShift' | translate)) +
      ('shiftTimes.labelLong.' + shift.control | baseBusinessKey | translate)
    "
  ></i>
</div>
